module.exports = __webpack_public_path__ + "static/media/remove_search--white.3153aad1.svg";